var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"shrink mx-1 pb-1 pt-0",attrs:{"append-icon":"mdi-magnify","label":"Search","single-line":"","hide-details":""},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }